import { Components, toggleButtonGroupClasses } from '@mui/material';
import { Theme } from '@mui/material/styles';

export const MuiToggleButtonGroup: Components<Theme>['MuiToggleButtonGroup'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`& .${toggleButtonGroupClasses.grouped}`]: {
        margin: theme.spacing(0.5),
        border: 0,
        [`&.${toggleButtonGroupClasses.disabled}`]: {
          border: 0,
        },
        '&:not(:first-of-type)': {
          borderRadius: theme.shape.borderRadius,
        },
        '&:first-of-type': {
          borderRadius: theme.shape.borderRadius,
        },
      },
    }),
  },
};
